import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import { getMenuListSelector } from '../../../selectors'

//const menuDetails =  MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'SUPPORT_CENTER')[0].children

export default function SupportCenter() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['SUPPORT_CENTER'] || {}
  return (
    <LayoutWithOutAccountCard
      breadCumKey='SUPPORT_CENTER'
      keyPath={'SUPPORT_CENTER'}
      showEmptySpace={true}>
      <Row>
      {Object.keys(menuConfig).length>0 && subMenuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
            <MenuCard
              handleMenuCallback={() => history.push(option.link)}
              icon={option.icon}
              name={option.title}
              description={option.desc}
              key={index}
            />
            }
          </>
        ))}
      </Row>
    </LayoutWithOutAccountCard>
  )
}
